import { render, staticRenderFns } from "./CompanyValues.vue?vue&type=template&id=01591dfa&"
import script from "./CompanyValues.vue?vue&type=script&lang=js&"
export * from "./CompanyValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports